module.exports = __webpack_public_path__ + "55353a0616332fe4d0f92e129a27425c.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ushahidi-platform-pattern-library/assets/img/material/svg-sprite-content-symbol.svg
// module id = 767
// module chunks = 0